import { faFlag, faPeopleArrows, faStar, faUsers } from "@fortawesome/free-solid-svg-icons";

export const leagueHostsRoleDescription = {
  roleId: 'leagueHosts',
  title: 'League Hosts',
  sections: [
    {
      id: 'overview',
      title: 'Overview',
      displayTitle: 'League Hosts',
      subtitle: 'Lead. Build. Grow.',
      description: 'League Hosts empower organizers of small online battles to bring their communities to Spitface Battles. Lead the community, drive engagement across the platform, and secure lifetime access to league features. Your participation directly influences the systems and experiences that will define online battle rap leagues on SFB.',
      contentItems: [
        '**Beta Window:** 12 months or until V1 launch',
        '**Signup Capacity:** 150'
      ],
      highlights: [
        "100 Official Spots",
        'Community Migration',
        'Organizer-Led',
      ],
      moreItems: [{
        key: "migration",
        label: "Migration",
        icon: faPeopleArrows
      }, {
        key: "leadership",
        label: "Leadership",
        icon: faFlag
      }, {
        key: "community",
        label: "Engagement",
        icon: faUsers
      }, {
        key: "feedback",
        label: "Feedback",
        icon: faStar
      }]
    },
    {
      id: 'whatYoullDo',
      title: "What You'll Do",
      description: 'Migrate, monitor, lead, and feedback. Keep communities alive, active, and well-managed.',
      lists: [{
        title: 'Core Duties',
        items: [
          'Migrate active users from existing channels and communities',
          'Run weekly check-ins to maintain activity momentum',
          'Lead Discord channels and guide members consistently',
          'Submit actionable feedback on league workflows monthly'
        ]
      }, {
        title: 'Collaboration & Communication',
        items: [
          'Coordinate with SFB on league feature testing and campaigns',
          'Set standards for league participation quality',
          'Maintain disciplined communication across beta'
        ]
      }],
      contentItems: [],
      tables: []
    },
    {
      id: 'whyThisRoleMatters',
      title: 'Why This Role Matters',
      description: 'Hosts shape community growth, retention, and operational quality. Strong hosts improve league tooling and platform standards.',
      contentItems: ['**Note:** This role is performance-based and manually verified.'],
      lists: [{
        title: 'This role directly helps:',
        items: [
          'Bring active users into the platform',
          'Maintain participation standards post-migration',
          'Improve league tools through real operational feedback'
        ]
      }],
      tables: []
    },
    {
      id: 'whatYouGet',
      title: 'What You Get',
      description: 'Recognition, premium access, and influence over league operations.',
      lists: [
        {
          title: 'Provisional Status',
          items: [
            'Earned by meeting first 3-month migration/engagement gate',
            'Progressive premium unlocks during beta',
            'Recognition as early league growth partner'
          ]
        },
        {
          title: 'Official Status',
          items: [
            'Top 100 most consistent hosts earn official status',
            'Lifetime league premium, permanent Hall of Fame listing, elevated league influence'
          ]
        },
        {
          title: 'Runner-Up Status',
          items: [
            'Retain premium value and recognition if outside official cap'
          ]
        }
      ],
      contentItems: [],
      tables: []
    },
    {
      id: 'expectations',
      title: 'Expectations',
      description: 'Phase-based metrics and weekly rhythm for migration, monitoring, leadership, and tool feedback.',
      lists: [{
        title: 'Performance Standards',
        items: [
          'Completion threshold target: 90%',
          'Evaluation includes reputation and cross-metric consistency',
          'Final status awarded by leaderboard-ranked sustained performance'
        ]
      }, {
        title: 'Typical Weekly Rhythm',
        items: [
          'Track and support migrated user activity',
          'Run check-ins and maintain participation',
          'Lead Discord conversations for league operations',
          'Submit actionable feedback on host tools monthly'
        ]
      }, {
        title: 'Consistency Markers',
        items: [
          'Stable migration quality over time',
          'Predictable check-in cadence',
          'Active community leadership presence'
        ]
      }],
      contentItems: ['**Important:** Thresholds may be adjusted before beta launch.'],
      tables: [{
        title: 'Requirements By Phase',
        headers: [
          '',
          'phase 1\nclosed beta',
          'phase 2\nopen beta',
          'phase 3\nopen beta',
        ],
        rows: [{
          requirement: 'migration',
          metric: 'active users',
          timeframe: 'monthly',
          phase1: '15',
          phase2: '10',
          phase3: '10',
          execution: 'Migrate active members who participate post-onboarding'
        }, {
          requirement: 'monitoring',
          metric: 'check-ins',
          timeframe: 'monthly',
          phase1: '4',
          phase2: '4',
          phase3: '4',
          execution: 'Track participation and re-engage inactive users'
        }, {
          requirement: 'leadership',
          metric: 'discord',
          timeframe: 'monthly',
          phase1: '8',
          phase2: '8',
          phase3: '8',
          execution: 'Lead discussions, guide members, and set standards'
        }, {
          requirement: 'feedback',
          metric: 'submissions',
          timeframe: 'monthly',
          phase1: '1',
          phase2: '1',
          phase3: '1',
          execution: 'Submit actionable feedback on league workflows and tools'
        }]
      }]
    },
    {
      id: 'whoShouldApply',
      title: 'Who Should Apply',
      description: 'Determine if you have the capacity, leadership, and operational skill to drive communities.',
      lists: [{
        title: 'Ideal For:',
        items: [
          'Operate organized battle communities',
          'Can migrate active participants, not just signups',
          'Maintain consistent leadership weekly',
          'Want direct influence on league tooling and operations'
        ]
      }, {
        title: 'Not Ideal For:',
        items: [
          'Cannot sustain recurring leadership activity',
          'Unprepared for performance-tracked accountability'
        ]
      }],
      contentItems: [],
      tables: []
    },
    {
      id: 'acknowledgements',
      title: 'Acknowledgements',
      description: 'Confirm understanding of role expectations, commitments, and community standards before joining.',
      lists: [{
        title: 'Commitment Checks',
        items: [
          'Commit to full-cycle host performance and accountability',
          'Accept manual verification of migration and engagement outcomes',
          'Participate in Discord during beta',
          'Complete all role acknowledgements in signup'
        ]
      }],
      contentItems: [],
      tables: []
    },
    {
      id: 'join',
      title: 'Join',
      description: 'Ready to step in? Confirm acknowledgements and complete your signup.',
      lists: [{
        title: 'Next Steps',
        items: [
          'Click Apply',
          'Check acknowledgements',
          'Confirm commitment in modal'
        ]
      }],
      contentItems: [],
      tables: []
    }
  ]
};
